import React from 'react';

import DashedLink from '../DashedLink';

const AddNewBinButton = ({onClick, isOpen, row, disabled}) => {

  const onLinkClick = (e) => {
    e.stopPropagation()
    onClick({type: 'bin', partnum: row.partnum})
  }

  return (
    (isOpen && !disabled && row.status !== 'accepted') ? (
      <DashedLink
        name="Add New Bin"
        onClick={onLinkClick}
      />
      ) : (
      <span>--</span>
    )
  );
}

export default AddNewBinButton;